import Card from './src/main';

/* istanbul ignore next */
Card.install = function(Vue) {
  Vue.component(Card.name, Card);
};

export default Card;



// WEBPACK FOOTER //
// ./src/components/element/packages/card/index.js